(() => {
  'use strict';
  if (window.TDGalleryAutoplay) return;
  const ROOTS = '#td-rampa-editorial,#td-majestuoso-editorial,#funda-editorial,#td-nails,#td-cama,#td-elevada,#td-comedero,#td-asiento,#td-nido,#td-piel-editorial,#td-luxury-editorial,#td-impermeable-editorial,[id^="MainProduct-"]';
  const GALLERIES = 'media-gallery,.gallery-stage,.hero-media,#td-piel-editorial .gallery-shell';
  const EXCLUDED = 'dialog,modal-dialog,cart-drawer,.product-media-modal,.thumbnail,.thumbnail-list,.gallery-thumbs,[aria-hidden="true"]';
  const groups = new Map();
  const videos = new Map();
  const roots = new Map();
  const motion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
  const labels = window.TDVideoLabels || {};
  let frame = 0, serial = 0, active = null, prefersSound = true, audioBlocked = false;
  const t = (key, fallback) => labels[key] || fallback;
  const sourceKey = video => video?.dataset.src || video?.getAttribute('src') || video?.querySelector('source')?.dataset.src || video?.querySelector('source')?.getAttribute('src') || '';
  const isHidden = node => !node?.isConnected || !!node.closest('[hidden],[aria-hidden="true"]') || !node.getClientRects().length;
  const suspended = () => document.hidden || !!document.querySelector('dialog[open],modal-dialog[open],.product-media-modal[open],cart-drawer.active,cart-notification.active,details.menu-drawer-container[open]');
  const automaticAllowed = () => !motion?.matches && !navigator.connection?.saveData;
  const managesVideo = video => !!(video?.matches?.('video') && video.closest(ROOTS) && !video.closest(EXCLUDED));
  function ratio(node) {
    if (isHidden(node)) return 0;
    const bounds = node.getBoundingClientRect();
    let left = Math.max(bounds.left, 0), right = Math.min(bounds.right, innerWidth);
    let top = Math.max(bounds.top, 0), bottom = Math.min(bounds.bottom, innerHeight);
    for (let parent = node.parentElement; parent && parent !== document.body; parent = parent.parentElement) {
      const style = getComputedStyle(parent);
      if (/(auto|scroll|hidden|clip)/.test(style.overflowX + style.overflowY)) {
        const clip = parent.getBoundingClientRect();
        if (/(auto|scroll|hidden|clip)/.test(style.overflowX)) { left = Math.max(left, clip.left); right = Math.min(right, clip.right); }
        if (/(auto|scroll|hidden|clip)/.test(style.overflowY)) { top = Math.max(top, clip.top); bottom = Math.min(bottom, clip.bottom); }
      }
    }
    return bounds.width > 0 && bounds.height > 0 ? Math.max(0, right - left) * Math.max(0, bottom - top) / (bounds.width * bounds.height) : 0;
  }
  function candidate(group) {
    if (!group.gallery) return isHidden(group.node) ? null : group.node;
    if (group.node.matches('media-gallery')) {
      const item = group.node.querySelector('.product__media-item.is-active');
      if (!item || isHidden(item)) return null;
      const deferred = item.querySelector('deferred-media');
      if (deferred && (deferred.querySelector('video') || deferred.querySelector('template')?.content.querySelector('video'))) return deferred;
      return item.querySelector('video');
    }
    return Array.from(group.node.querySelectorAll('video')).find(video => !isHidden(video) && !video.closest(EXCLUDED)) || null;
  }
  function visible(state) {
    return !suspended() && candidate(state.group) === state.node && ratio(state.node) >= .55;
  }
  function pause(state) {
    state.epoch += 1;
    state.pending = false;
    state.manualPlayback = false;
    if (state.video && !state.video.paused) state.video.pause();
    update(state.group);
  }
  function stopOthers(except) {
    for (const state of videos.values()) if (state !== except && (!state.video.paused || state.pending)) pause(state);
  }
  function setMuted(video, muted) {
    video.muted = muted;
    video.defaultMuted = muted;
    video.toggleAttribute('muted', muted);
  }
  function enforce(video) {
    if (video.controls) video.controls = false;
    if (video.hasAttribute('controls')) video.removeAttribute('controls');
    if (video.autoplay) video.autoplay = false;
    if (video.hasAttribute('autoplay')) video.removeAttribute('autoplay');
    video.playsInline = true;
    if (!video.hasAttribute('playsinline')) video.setAttribute('playsinline', '');
    if (!video.hasAttribute('webkit-playsinline')) video.setAttribute('webkit-playsinline', '');
  }
  function loadSources(video) {
    let changed = false;
    if (video.dataset.poster && !video.poster) video.poster = video.dataset.poster;
    if (video.dataset.src && video.getAttribute('src') !== video.dataset.src) { video.src = video.dataset.src; changed = true; }
    video.querySelectorAll('source[data-src]').forEach(source => {
      if (source.getAttribute('src') !== source.dataset.src) { source.src = source.dataset.src; changed = true; }
    });
    if (changed || video.error) video.load();
  }
  function update(group) {
    const node = candidate(group);
    const state = node?.matches('video') ? videos.get(node) : videos.get(node?.querySelector('video'));
    const hidden = !node || (!state && !node.matches('deferred-media'));
    if (group.bar.hidden !== hidden) group.bar.hidden = hidden;
    if (!state) return;
    const playing = !state.video.paused && !state.video.ended;
    const title = state.video.getAttribute('aria-label') || '';
    const playLabel = state.failed ? t('retry', 'Reintentar video') : playing ? t('pause', 'Pausar') : t('play', 'Reproducir');
    if (group.play.textContent !== playLabel) group.play.textContent = playLabel;
    group.play.setAttribute('aria-label', title ? playLabel + ': ' + title : playLabel);
    group.play.setAttribute('aria-pressed', String(playing));
    group.play.setAttribute('aria-controls', state.video.id);
    const soundLabel = state.video.muted ? t('sound_on', 'Activar sonido') : t('sound_off', 'Silenciar');
    if (group.sound.textContent !== soundLabel) group.sound.textContent = soundLabel;
    group.sound.setAttribute('aria-pressed', String(!state.video.muted));
    group.sound.setAttribute('aria-controls', state.video.id);
    const silent = state.video.audioTracks?.length === 0;
    if (group.sound.hidden !== silent) group.sound.hidden = silent;
  }
  function makeBar(group) {
    const bar = document.createElement('div');
    bar.className = 'td-pdp-video-controls';
    bar.hidden = true;
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', t('controls', 'Controles del video'));
    const playButton = document.createElement('button');
    const soundButton = document.createElement('button');
    playButton.type = soundButton.type = 'button';
    playButton.textContent = t('play', 'Reproducir');
    soundButton.textContent = t('sound_on', 'Activar sonido');
    bar.append(playButton, soundButton);
    group.bar = bar; group.play = playButton; group.sound = soundButton;
    if (group.gallery) group.node.after(bar);
    else {
      const frame = group.node.closest('.ugc-media,.motion-media');
      const card = group.node.closest('.video-card');
      if (frame) frame.after(bar);
      else if (card && card.nodeName !== 'BUTTON') {
        const wrap = document.createElement('div');
        wrap.className = 'td-pdp-video-block';
        card.before(wrap); wrap.append(card, bar);
      } else group.node.after(bar);
    }
    playButton.addEventListener('click', () => {
      const state = resolve(group, true);
      if (!state) return;
      if (!state.video.paused || state.pending) { state.manualPause = true; pause(state); }
      else play(state.video, { manual: true });
    });
    soundButton.addEventListener('click', () => {
      const state = resolve(group, true);
      if (!state) return;
      prefersSound = state.video.muted;
      if (prefersSound) { audioBlocked = false; if (state.pending) pause(state); play(state.video, { manual: true }); }
      else { setMuted(state.video, true); update(group); }
    });
  }
  function attach(video, group, node = video) {
    if (!managesVideo(video)) return null;
    if (videos.has(video)) return videos.get(video);
    const state = { video, node, group, key: sourceKey(video), epoch: 0, pending: false, manualPause: false, blocked: false, failed: false };
    videos.set(video, state);
    video.dataset.tdVideoManaged = 'true';
    if (!video.id) video.id = 'td-pdp-video-' + (++serial);
    enforce(video);
    video.preload = 'none';
    if (!video.paused) video.pause();
    video.addEventListener('play', () => {
      if (!visible(state)) { pause(state); return; }
      if (!state.pending) {
        pause(state);
        start(state, false);
        return;
      }
      stopOthers(state);
      active = state;
      state.failed = false;
      const posterFrame = video.closest('.ugc-media');
      if (posterFrame) posterFrame.dataset.started = 'true';
      update(group);
    });
    video.addEventListener('pause', () => update(group));
    video.addEventListener('volumechange', () => update(group));
    video.addEventListener('ended', () => { if (!video.loop) state.manualPause = true; update(group); });
    video.addEventListener('error', () => { state.failed = true; state.blocked = true; state.pending = false; update(group); });
    return state;
  }
  function resolve(group, load = false) {
    const node = candidate(group);
    if (!node) return null;
    let video = node.matches('video') ? node : node.querySelector('video');
    if (!video && load && node.matches('deferred-media') && typeof node.loadContent === 'function') {
      const media = node.loadContent(false, true);
      if (media?.nodeName === 'VIDEO') video = media;
    }
    return video ? attach(video, group, node) : null;
  }
  function start(state, manual) {
    if (!state || !visible(state) || state.pending || (!manual && (state.manualPause || state.blocked || !automaticAllowed()))) return;
    const video = state.video;
    const key = sourceKey(video);
    if (!key) return;
    if (key !== state.key) { state.key = key; state.manualPause = false; state.blocked = false; state.failed = false; }
    if (manual) { state.manualPause = false; state.blocked = false; state.failed = false; }
    stopOthers(state);
    active = state;
    state.manualPlayback = manual;
    enforce(video);
    loadSources(video);
    const audible = prefersSound && (manual || !audioBlocked);
    setMuted(video, !audible);
    const epoch = ++state.epoch;
    state.pending = true;
    const attempt = () => { try { return Promise.resolve(video.play()); } catch (error) { return Promise.reject(error); } };
    attempt().catch(error => {
      if (epoch !== state.epoch || !visible(state)) throw error;
      if (!audible || error?.name !== 'NotAllowedError') throw error;
      audioBlocked = true;
      setMuted(video, true);
      return attempt();
    }).then(() => {
      if (epoch !== state.epoch) return;
      state.pending = false;
      if (!visible(state)) pause(state);
      update(state.group);
    }).catch(error => {
      if (epoch !== state.epoch) return;
      state.pending = false;
      if (error?.name !== 'AbortError') { state.blocked = true; state.failed = error?.name !== 'NotAllowedError'; }
      update(state.group);
    });
  }
  function play(video, { manual = false } = {}) {
    if (!managesVideo(video)) return;
    init(video.closest(ROOTS));
    const state = videos.get(video);
    if (state) start(state, manual);
  }
  function sync() {
    frame = 0;
    const eligible = [];
    for (const [node, group] of groups) {
      if (!node.isConnected) { group.bar.remove(); groups.delete(node); continue; }
      const current = candidate(group);
      if (group.current !== current) {
        const previous = group.current?.matches?.('video') ? videos.get(group.current) : videos.get(group.current?.querySelector?.('video'));
        if (previous) pause(previous);
        group.current = current;
      }
      if (current && !suspended() && ratio(current) >= .55 && group.ready) eligible.push(group);
      update(group);
    }
    for (const [video, state] of videos) {
      if (!video.isConnected) { pause(state); videos.delete(video); continue; }
      enforce(video);
      const key = sourceKey(video);
      if (key !== state.key) { pause(state); state.key = key; state.manualPause = false; state.blocked = false; state.failed = false; }
      if (!visible(state)) pause(state);
    }
    if (suspended() || !automaticAllowed()) { for (const state of videos.values()) if (!state.manualPlayback) pause(state); return; }
    if (active && visible(active) && active.manualPause) return;
    const retained = active && visible(active) && !active.manualPause && (!active.video.paused || active.pending) ? active.group : null;
    const next = retained || eligible.find(group => {
      const state = resolve(group);
      return !state || (!state.manualPause && !state.blocked);
    });
    if (next) {
      const state = resolve(next, true);
      if (state && state.video.paused && !state.pending) start(state, false);
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(sync); }
  function ready(group) {
    const image = group.gallery ? group.node.querySelector('img') : group.node.closest(ROOTS)?.querySelector('.gallery-stage img,.hero-media img,media-gallery img');
    const release = () => {
      const finish = () => { group.ready = true; schedule(); };
      if ('requestIdleCallback' in window) requestIdleCallback(finish, { timeout: 1200 });
      else requestAnimationFrame(() => requestAnimationFrame(finish));
    };
    if (!image || image.complete) release();
    else { image.addEventListener('load', release, { once: true }); image.addEventListener('error', release, { once: true }); }
  }
  function addGroup(node, gallery) {
    if (groups.has(node)) return groups.get(node);
    const group = { node, gallery, ready: false, current: null };
    groups.set(node, group);
    makeBar(group);
    if (gallery) {
      node.dataset.tdVideoGallery = 'true';
      node.querySelectorAll('video').forEach(video => attach(video, group, node.matches('media-gallery') ? video.closest('deferred-media') || video : video));
    } else attach(node, group);
    ready(group);
    return group;
  }
  function init(scope = document) {
    const found = [...(scope.matches?.(ROOTS) ? [scope] : []), ...scope.querySelectorAll?.(ROOTS) || []];
    found.forEach(root => {
      root.querySelectorAll(GALLERIES).forEach(node => { if (!node.closest(EXCLUDED)) addGroup(node, true); });
      root.querySelectorAll('video').forEach(video => {
        if (!managesVideo(video)) return;
        const gallery = video.closest(GALLERIES);
        if (gallery) attach(video, addGroup(gallery, true), gallery.matches('media-gallery') ? video.closest('deferred-media') || video : video);
        else addGroup(video, false);
      });
      if (roots.has(root)) return;
      const observer = new MutationObserver(records => {
        if (records.some(record => record.type === 'childList' && Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('video,media-gallery,deferred-media') || node.querySelector?.('video'))))) init(root);
        schedule();
      });
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'aria-hidden', 'src', 'data-src', 'controls', 'open'] });
      roots.set(root, observer);
    });
    document.querySelectorAll('cart-drawer,cart-notification,dialog,modal-dialog').forEach(node => {
      if (node.dataset.tdVideoObserved) return;
      node.dataset.tdVideoObserved = 'true';
      new MutationObserver(schedule).observe(node, { attributes: true, attributeFilter: ['open', 'class', 'hidden'] });
    });
    schedule();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-video-toggle],#video-play,#gallery-video-play,.ugc-play,.video-play');
    const root = button?.closest(ROOTS);
    if (!root || button.closest(EXCLUDED)) return;
    const id = button.getAttribute('aria-controls');
    const video = (id ? document.getElementById(id) : null)
      || button.closest('.ugc-media,.motion-media,.video-card,.gallery-stage')?.querySelector('video')
      || root.querySelector('#editorial-video');
    if (!managesVideo(video)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    init(root);
    const state = videos.get(video);
    if (!state) return;
    if (button.matches('[data-video-toggle]') && (!video.paused || state.pending)) { state.manualPause = true; pause(state); }
    else play(video, { manual: true });
  }, true);
  document.addEventListener('visibilitychange', () => { if (document.hidden) videos.forEach(pause); else schedule(); });
  document.addEventListener('td:gallery-media-change', schedule);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, observer] of roots) if (event.target.contains(root)) { observer.disconnect(); roots.delete(root); }
    for (const state of videos.values()) if (event.target.contains(state.video)) pause(state);
    schedule();
  });
  window.addEventListener('pagehide', () => videos.forEach(pause));
  window.addEventListener('pageshow', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  motion?.addEventListener?.('change', schedule);
  navigator.connection?.addEventListener?.('change', schedule);
  window.TDGalleryAutoplay = Object.freeze({ init, refresh: schedule, managesVideo, play });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
